import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChartsComponent } from '@app/charts/charts/charts.component';

import { AirlineGuard } from '@app/core/guards/airline.guard';

const routes: Routes = [
  { path: '', canActivate: [AirlineGuard], component: ChartsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChartsRoutingModule { }
